import { useCallback, useSyncExternalStore } from "react";

const noop = () => undefined;

const getMediaQueryList = (query: string) => {
  if (
    typeof window === "undefined" ||
    typeof window.matchMedia !== "function"
  ) {
    return undefined;
  }

  return window.matchMedia(query);
};

export const useViewport = (query: string) => {
  const subscribe = useCallback(
    (callback: () => void) => {
      const mediaQueryList = getMediaQueryList(query);

      if (!mediaQueryList) {
        if (typeof window === "undefined") {
          return noop;
        }

        window.addEventListener("resize", callback);

        return () => window.removeEventListener("resize", callback);
      }

      if (typeof mediaQueryList.addEventListener === "function") {
        mediaQueryList.addEventListener("change", callback);

        return () => mediaQueryList.removeEventListener("change", callback);
      }

      mediaQueryList.addEventListener("change", callback);

      return () => mediaQueryList.removeEventListener("change", callback);
    },
    [query],
  );

  const getSnapshot = useCallback(() => {
    const mediaQueryList = getMediaQueryList(query);

    return Boolean(mediaQueryList?.matches);
  }, [query]);

  return useSyncExternalStore(subscribe, getSnapshot);
};
